import React, {PureComponent, PropTypes} from 'react';
import Modal from 'react-modal';
import cx from 'classnames';

import style from './team.module.css';
import modalStyle from '../modal.module.css';

class TeamMemberSelect extends PureComponent {

    static propTypes = {
        onClose: PropTypes.func,
        open: PropTypes.bool,
        init: PropTypes.bool,
        teamId: PropTypes.number,
        title: PropTypes.string,
        image: PropTypes.string
    };

    constructor() {
        super();

        this.state = {};
    }

    _submitForm = (e) => {
        e.preventDefault();

        const title = this._nameInput.value;

        const formInput = new FormData();
        formInput.append('logo', this._logoInput.files[0]);
        formInput.append('title', title);
        if (this.props.teamId) {
            formInput.append('id', this.props.teamId)
        }

        if (!title) {
            return this.setState({
                error: Exanimo.trans('missing_title')
            });
        }

        this.setState({
            loading: true
        });

        fetch('/teams/', {
            credentials: 'same-origin',
            method: 'post',
            body: formInput,
            headers:{'X-CSRF-TOKEN': Exanimo.CSRF}
        }).then((response) => {

            if (response.status !== 200) {
                throw new Error(Exanimo.trans('request_failed'));
            }

            return response.json();
        }).then((data) => {
            if (data.ok) {
                document.location.href = '/teams/';
            } else {
                throw new Error(data.error);
            }
        }).catch((err) => {
            this.setState({
                loading: false,
                error: err.message
            });
        });
    }

    componentWillReceiveProps(props) {
        if (props.init) {
            this._resetState();
        }
    }

    _resetState() {
        this.setState({
            error: '',
            loading: false
        });
    }

    render() {

        const customStyles = {
            overlay : {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                zIndex: 2
            },
            content : {
                top                   : '50%',
                left                  : '50%',
                right                 : 'auto',
                bottom                : 'auto',
                marginRight           : '-50%',
                transform             : 'translate(-50%, -50%)',
                backgroundColor       : '#F1F1F1',
                color                 : '#333333',
                padding               : '0'
            }
        };

        const error = (this.state.error) ? <div className={modalStyle.error}>{this.state.error}</div> : '';
        const saveButtonText = (this.state.loading) ? '. . .' :  Exanimo.trans('save');
        const buttonClasses = cx(modalStyle.button, style.button);

        return (
            <Modal
                isOpen={this.props.open}
                onRequestClose={this.props.onClose}
                contentLabel="Team"
                style={customStyles}
            >
                <div className={style.container}>
                    <a href="" onClick={this.props.onClose} className={modalStyle.close}/>

                    <div className={style.content}>
                        <h3>{Exanimo.trans('create_team')}</h3>
                        <form onSubmit={this._submitForm}>
                            {error}
                            <p className={modalStyle.subtitle}>{Exanimo.trans('team_logo')}</p>
                            <input ref={(input) => {this._logoInput = input}} type="file"/>

                            <p className={modalStyle.subtitle}>{Exanimo.trans('team_name')} <span className={modalStyle.required}>*</span></p>
                            <input ref={(input) => {this._nameInput = input}} className={style.input} defaultValue={this.props.title}/>

                            <div className={style.actionContainer}>
                                <a onClick={this._submitForm} className={buttonClasses}>{saveButtonText}</a>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>);
    }
}

export default TeamMemberSelect;